<template>
  <div class="ProfileStrengthMeter" aria-live="polite">
    <div class="ProfileStrengthMeter__top">
      <span class="ProfileStrengthMeter__title">{{ $t('registration_profile_strength_label') }}</span>
      <span class="ProfileStrengthMeter__word" data-e2e="profileStrengthLabel">{{ $t(labelKey) }}</span>
    </div>
    <div class="ProfileStrengthMeter__meter">
      <span
        v-for="(segment, index) in segments"
        :key="index"
        class="ProfileStrengthMeter__segment"
        :class="{ ProfileStrengthMeter__segment_on: segment }"
      ></span>
    </div>
    <div class="ProfileStrengthMeter__hint">{{ $t('registration_profile_strength_hint') }}</div>
  </div>
</template>

<script>
export default {
  name: 'ProfileStrengthMeter',
  props: {
    occupation: { type: String, default: '' },
    aboutMe: { type: String, default: '' },
    interestsCount: { type: Number, default: 0 }
  },
  computed: {
    points() {
      // The first segment is always full ("just the basics"); the others light up
      // as the participant adds occupation, About me and three or more interests.
      let points = 0
      if (this.occupation && this.occupation.trim()) points += 1
      if (this.aboutMe && this.aboutMe.trim()) points += 1
      if (this.interestsCount >= 3) points += 1
      else if (this.interestsCount >= 1) points += 0.5
      return points
    },
    segments() {
      return [true, this.points >= 1, this.points >= 2, this.points >= 3]
    },
    labelKey() {
      // Wording is provisional (LL-169); selection is driven by the numeric score
      // only so a copy pass is a pure string swap.
      if (this.points >= 3) return 'registration_profile_strength_standout'
      if (this.points >= 2) return 'registration_profile_strength_looking_good'
      if (this.points >= 1) return 'registration_profile_strength_nice_start'
      return 'registration_profile_strength_just_basics'
    }
  }
}
</script>

<style lang="scss" scoped>
.ProfileStrengthMeter {
  @apply border border-neutral-01-50 rounded bg-bg-01 p-4;
  &__top {
    @apply flex justify-between items-baseline mb-2;
  }
  &__title {
    @apply font-semibold text-body-02;
  }
  &__word {
    @apply text-body-02 font-semibold text-success-01;
  }
  &__meter {
    @apply flex;
  }
  &__segment {
    @apply flex-1 h-1.5 rounded bg-neutral-01-50 mx-0.5;
    transition: background 0.3s;

    &:first-child {
      @apply ml-0;
    }
    &:last-child {
      @apply mr-0;
    }
    &_on {
      @apply bg-success-01;
    }
  }
  &__hint {
    @apply text-caption-01 text-neutral-01-400 mt-2;
  }
}
</style>
